import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import LogRocket from 'logrocket';
import { auth, onAuthStateChanged } from './firebase';

// Initialize LogRocket with sanitization options
LogRocket.init('9qbnag/protegosafe', {
  dom: {
    textSanitizer: true,
    inputSanitizer: true,
  },
});

// Set up LogRocket user identification
onAuthStateChanged(auth, (user) => {
  if (user) {
    LogRocket.identify(user.uid, {
      name: user.displayName || 'Unknown User',
      email: user.email || '',
      // Add additional user data as needed
      emailVerified: user.emailVerified
    });
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
